import { createStore } from 'redux';
import rootReducer from "../libs/redux/reducer";

// noinspection JSDeprecatedSymbols
const store = createStore(rootReducer);

export default store;


// WEBPACK FOOTER //
// ./src/modules/stores.js